import {FC} from "react";
import {
  IPeople,
  IPrevPeople,
} from "../../../pages/StateInitiative/StateInitiative.type";
import SidebarCardHeader from "../../SidebarCardHeader";
import {Container, MainContent} from "../styles";
import {SidebarContentOrganisationWorker} from "../SidebarCardContent/SidebarContentOrganisationWorker";
import {Loader} from "../../../ui/Loader";
import {SidebarTab} from "../../Sidebar";
import {ITypeRadar} from "../../../types";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
  activeWorker?: IPeople;
  arrPersonsWorker?: IPeople[];
  setIdWorkerShowConnections?: (id: string) => void;
  prevIdWorker?: IPrevPeople[];
  setPrevIdWorker?: (PrevPeople: IPrevPeople[]) => void;
  isLoading?: boolean;
  openWorkerRadar?: () => void;
  openOrganisationsRadar?: (documentId: string) => void;
  onWorkerDataChange?: (workerData: any) => void;
  openSidebarWithTab?: (
    tab: SidebarTab,
    directionId: number | string,
    trendId?: number | string,
    trendTitle?: string,
    sectionName?: string,
    segmentColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar,
    isSearchPanelActive?: boolean
  ) => void;
  isFromOrganisationsPage?: boolean; // Новый проп
  isLogin?: boolean;
  role?: string | null;
  userIdAuth?: string | null;
  roleAuth?: string | null;
}

export const SidebarCardWorkerNew: FC<IProps> = ({
  isOpen,
  onClose,
  onBack,
  activeWorker,
  arrPersonsWorker,
  setIdWorkerShowConnections,
  prevIdWorker,
  setPrevIdWorker,
  isLoading,
  openWorkerRadar,
  openOrganisationsRadar,
  onWorkerDataChange,
  openSidebarWithTab,
  isFromOrganisationsPage = false,
  isLogin = false,
  role = null,
  userIdAuth = null,
  roleAuth = null,
}) => {
  if (!isOpen || !activeWorker) {
    return null;
  }

  const handleWorkerChange = (workerData: any) => {
    if (onWorkerDataChange) {
      onWorkerDataChange(workerData);
    }
  };

  const handleInitiativeClick = (initiativeName: string) => {
    if (openSidebarWithTab && activeWorker?.initiatives) {
      const initiative = activeWorker.initiatives.find(
        (init) => init.initiative?.name === initiativeName
      );

      if (initiative?.initiative) {
        if (setPrevIdWorker) {
          setPrevIdWorker([]);
        }

        onClose();

        openSidebarWithTab(
          SidebarTab.StateInitiative,
          initiative.initiative.segment?.documentId || "",
          initiative.initiative.documentId,
          initiative.initiative.name,
          initiative.initiative.segment?.name
        );
      }
    }
  };

  const handleBack = () => {
    if (setPrevIdWorker) {
      setPrevIdWorker([]);
    }
    if (onBack) {
      onBack();
    } else {
      onClose();
    }
  };

  const handleBackInHistory = () => {
    if (
      prevIdWorker &&
      prevIdWorker.length > 0 &&
      setIdWorkerShowConnections &&
      setPrevIdWorker
    ) {
      const lastWorker = prevIdWorker[prevIdWorker.length - 1];
      setIdWorkerShowConnections(lastWorker.documentId);
      setPrevIdWorker(prevIdWorker.slice(0, prevIdWorker.length - 1));
    }
  };

  const isBackAvailable = true;

  return (
    <Container style={{width: 500, position: "relative"}}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(12, 12, 12, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            borderRadius: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Loader size={40} />
            <div style={{color: "#FAFAFA", fontSize: "14px"}}>
              Загрузка данных сотрудника...
            </div>
          </div>
        </div>
      )}

      <SidebarCardHeader
        title="Описание работника"
        previewTitle={activeWorker.fullName || "Работник"}
        onClose={onClose}
        color="#3290B7"
        colorTitle="#3290B7"
        isBackAvailable={isBackAvailable}
        onBackApply={handleBack}
        isShowClose={false}
      />
      <MainContent>
        <div style={{padding: "0 20px", height: "100%"}}>
          <SidebarContentOrganisationWorker
            worker={activeWorker}
            arrPersonsWorker={arrPersonsWorker}
            setIdWorkerShowConnections={setIdWorkerShowConnections}
            prevIdWorker={prevIdWorker}
            setPrevIdWorker={setPrevIdWorker}
            onBack={handleBackInHistory}
            onWorkerChange={handleWorkerChange}
            onInitiativeClick={handleInitiativeClick}
            openOrganisationsRadar={openOrganisationsRadar}
            isLoading={isLoading}
            isFromOrganisationsPage={isFromOrganisationsPage}
            isLogin={isLogin}
            role={role}
            userIdAuth={userIdAuth}
            roleAuth={roleAuth}
          />
        </div>
      </MainContent>
    </Container>
  );
};
